import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import SignaturePad from 'react-signature-pad-wrapper';

import { Dialog } from '@mui/material';

import Button from '../formElements/Button';

import local from './styles/eSignatureModal.module.css';

const ESignatureModal = ({
    dialogOpen,
    onSignatureModalClose,
    onSignatureSave,
    onSignatureSkip,
    signerName
}) => {
    const signaturePadRef = useRef(null);
    const [isEmpty, setIsEmpty] = useState(true);

    // HELPER FNS
    const clearPad = () => {
        signaturePadRef.current?.clear();
        updateDisabled();
    };

    const updateDisabled = () => {
        setIsEmpty(signaturePadRef?.current?.isEmpty());
    };

    const signerSignatureString = useMemo(() => {
        if (!signerName) return 'Signature';
        if (signerName[signerName.length - 1].toLowerCase() === 's')
            return `${signerName}' Signature`;
        else return `${signerName}'s Signature`;
    }, [signerName]);

    // USE EFFECTS
    useEffect(() => {
        let sigPad;
        if (dialogOpen) {
            const timeoutId = setTimeout(() => {
                sigPad = signaturePadRef.current?.signaturePad;
                sigPad?.addEventListener('endStroke', updateDisabled);
            }, 0);

            return () => {
                clearTimeout(timeoutId);
                sigPad?.removeEventListener('endStroke', updateDisabled);
                setIsEmpty(true);
            };
        }
    }, [dialogOpen]);

    // EVENT HANDLERS
    const onConfirm = () => {
        const sigData =
            signaturePadRef.current
                ?.toDataURL()
                .slice(1 + signaturePadRef.current?.toDataURL().indexOf(',')) || null;
        onSignatureSave(sigData);
        onSignatureModalClose();
    };

    // RENDER
    return (
        <Dialog open={dialogOpen}>
            <div className={local.eSigModal}>
                <div className={local.eSigHeaderRow}>
                    <h3>{signerSignatureString}</h3>
                    <Button id="skipButton" type="text" content="Skip" onClick={onSignatureSkip} />
                </div>
                <div>
                    <div className={local.eSigPadWrapper}>
                        <div className={local.eSigPad} id="eSigPad" data-testid="eSigPad">
                            <SignaturePad
                                width={200}
                                height={150}
                                ref={signaturePadRef}
                                options={{
                                    minWidth: 1,
                                    maxWidth: 2,
                                    penColor: 'rgb(0, 0, 0)'
                                }}
                            />
                        </div>
                    </div>
                    <div className={local.eSigPadPrompt}>Sign your name</div>
                </div>
                <div className={local.eSigModalButtons}>
                    <Button
                        id="resetButton"
                        disabled={isEmpty}
                        type="text"
                        content="Reset"
                        onClick={clearPad}
                    />
                    <Button
                        id="confirmButton"
                        disabled={isEmpty}
                        type="text"
                        content="Confirm"
                        onClick={onConfirm}
                    />
                    <Button
                        id="cancelButton"
                        type="text"
                        content="Return"
                        onClick={onSignatureModalClose}
                    />
                </div>
            </div>
        </Dialog>
    );
};

ESignatureModal.propTypes = {
    dialogOpen: PropTypes.bool,
    onSignatureModalClose: PropTypes.func,
    onSignatureSave: PropTypes.func,
    onSignatureSkip: PropTypes.func,
    signerName: PropTypes.string
};

export default ESignatureModal;
